// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Google Reviews (Elfsight) section ---------- */
.google-reviews { background: var(--cream); }
.google-reviews .section-head { margin-bottom: 46px; }

/* min-height prevents page "jump" while the widget loads */
.gr-widget-wrap { min-height: 400px; }`, "",{"version":3,"sources":["webpack://./src/styles/GoogleReviews.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D,kBAAkB,wBAAwB,EAAE;AAC5C,gCAAgC,mBAAmB,EAAE;;AAErD,2DAA2D;AAC3D,kBAAkB,iBAAiB,EAAE","sourcesContent":["/* ---------- Google Reviews (Elfsight) section ---------- */\r\n.google-reviews { background: var(--cream); }\r\n.google-reviews .section-head { margin-bottom: 46px; }\r\n\r\n/* min-height prevents page \"jump\" while the widget loads */\r\n.gr-widget-wrap { min-height: 400px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
